export default {
  name: "Appendix B - Additional Worksites",
  pageAlert: {
    widget: "pageAlert",
    alerts: [
      {
        title: "Information Required",
        description:
          "Please specify in Field E.c.9 whether work is being performed at multiple worksites.",
        type: "info",
        isVisible: {
          when: "ec9_is_multiple_locations",
          is: "untouched",
          operator: "untouched",
        },
      },
      {
        title: "Section Complete",
        description: `Because you indicated that work is only being performed at one worksite (per Field E.c.9), no Appendix B is necessary for this application.`,
        type: "success",
        isVisible: {
          when: "ec9_is_multiple_locations",
          is: "NO",
        },
      },
    ],
  },
  pageInfo: {
    text: `Identify the geographic place(s) of employment indicating each metropolitan statistical area (MSA) or the independent city(ies)/township(s)/county(ies) (borough(s)/parish(es)) and the corresponding state(s) where work will be performed. If necessary, submit a second completed Form ETA-9141C with a listing of the additional anticipated worksites. Please note that wages cannot be provided for unspecified/unanticipated locations. §`,
    coloring: `grey`,
    isVisible: {
      when: "ec9_is_multiple_locations",
      is: "YES",
    },
  },
  sections: [
    {
      code: "Addendum B",
      name: "Other Worksites",
      isVisible: {
        when: "ec9_is_multiple_locations",
        is: "YES",
      },
      // Leaving in for possible migration
      // isModal: true,
      // openModalHeader: "Add Addendum B",
      // modalHeader: "Add Other Worksite",
      // label:
      //   "Use the table below to enter the details about each worksite, when applicable.",
      // listType: "table",
      // maxLength: 250,
      // removeFromFieldArray: true,
      fields: [
        {
          machine_name: "appx_b",
          widget: "tableLoader",
          widgetConfig: {
            fromField: "appx_b_locations",
            toField: "appx_b",
            buttonText: "Add Worksites",
          },
        },
        {
          code: "Appendix B",
          machine_name: "appx_b",
          widget: "tableEditor",
          validate: ["tableRequired", "tableIncomplete"],
          fromFields: [
            "eb2_num_workers",
            "eb3_start_date",
            "eb4_end_date",
            // "_blsCounties",
          ],
        },
      ],
      // Leaving in for possible migration
      // modalFields: [
      //   {
      //     machine_name: "appx_b_city",
      //     label: "City",
      //     widget: "text",
      //     maxLength: 20,
      //     validate: ["required"],
      //   },
      //   {
      //     machine_name: "appx_b_state_id",
      //     label: "State",
      //     widget: "select",
      //     // placeholder: ["NORTHERN MARIANA ISLANDS"],
      //     selection: ["NORTHERN MARIANA ISLANDS"],
      //     validate: ["required"],
      //     // disabled: true,
      //   },
      //   {
      //     machine_name: "appx_b_zip",
      //     label: "Postal Code",
      //     widget: "text",
      //     maxLength: 20,
      //     validate: [
      //       "required",
      //       { postalCompare: ["96950", "96951", "96952"] },
      //       "noNAs",
      //     ],
      //   },
      //   {
      //     machine_name: "appx_b_employment_info",
      //     hideOnTable: true,
      //     widget: "text_area",
      //     inputLimit: 120,
      //     label: "Additional Place of Employment Information",
      //     tooltip:
      //       "Enter any additional details or information about the place of employment where work will be performed, if applicable.",
      //     width: 9,
      //     rows: 4,
      //   },
      //   {
      //     machine_name: "appx_b_crew_id",
      //     hideOnTable: true,
      //     widget: "text",
      //     maxLength: 2,
      //     label: "Crew ID",
      //     tooltip:
      //       "Enter a single-digit number or letter to identify each crew of workers, as applicable.",
      //     width: 3,
      //   },
      //   {
      //     machine_name: "appx_b_total_workers",
      //     hideOnTable: true,
      //     widget: "number",
      //     maxLength: 4,
      //     label: "Total Workers",
      //     tooltip:
      //       "Whether associated with a distinct work crew or not, enter the total number of workers expected to perform work at the worksite location, as applicable.",
      //     width: 3,
      //   },
      //   {
      //     machine_name: "appx_b_begin_date",
      //     hideOnTable: true,
      //     widget: "date",
      //     label: "Begin Date",
      //     tooltip:
      //       "Enter the expected start date for the period of employment at this worksite location, as applicable.  Use a month/day/year (mm/dd/yyyy) format.",
      //   },
      //   {
      //     machine_name: "appx_b_end_date",
      //     hideOnTable: true,
      //     widget: "date",
      //     label: "End Date",
      //     tooltip:
      //       "Enter the expected end date for the period of employment at this worksite location, as applicable.  Use a month/day/year (mm/dd/yyyy) format.",
      //   },
      //   {
      //     machine_name: "appx_b_wage_from",
      //     hideOnTable: true,
      //     widget: "text",
      //     placeholder: "$",
      //     width: 5,
      //     maxLength: 10,
      //     label: "Basic Wage Rate (From)",
      //     tooltip:
      //       "Enter the basic rate of pay to be paid for the period of employment at this worksite location, if applicable. If the wage offer is expressed as a range, enter the bottom of the wage range to be paid on the “From” line and enter the top of the wage range on the “To” line.",
      //   },
      //   {
      //     machine_name: "appx_b_wage_to",
      //     hideOnTable: true,
      //     widget: "text",
      //     placeholder: "$",
      //     width: 5,
      //     maxLength: 10,
      //     label: "Basic Wage Rate (To)",
      //     tooltip:
      //       "Enter the basic rate of pay to be paid for the period of employment at this worksite location, if applicable. If the wage offer is expressed as a range, enter the bottom of the wage range to be paid on the “From” line and enter the top of the wage range on the “To” line.",
      //   },
      //   {
      //     machine_name: "appx_b_wage_freq",
      //     hideOnTable: true,
      //     widget: "select",
      //     placeholder: "- Select -",
      //     width: 5,
      //     tooltip:
      //       "Enter the following two-letter designations for the unit of pay, as applicable: “HR” –hourly; “WK” –weekly; “BW” –biweekly; “MH” –monthly; “YR” year; or “PR” piece rate.",
      //     label: "Per (Choose only one)",
      //     selection: [
      //       "Hour",
      //       "Week",
      //       "Bi-Weekly",
      //       "Month",
      //       "Year",
      //       "Piece Rate",
      //     ],
      //   },
      // ],
    },
  ],
};
